import React from 'react';
import './Pages.css';

// Reports moved to Framework & Report page

function SuccessStories() {

  return (
    <>
      <section className="success-hero">
        <div className="success-hero-background">
          <img src="/assest/img/kub.png" alt="Background" />
        </div>
        <div className="success-hero-overlay">
          <div className="success-hero-container">
            <div className="success-hero-content">
              <div className="success-hero-text">
                <h1 className="success-hero-title">
                  <span className="title-line">From Vision </span>
                  <span className="title-line">to Victory</span>
                </h1>
                <p className="success-hero-subtitle">
                  Inspiring Innovators, Creating Futures
                </p>
                <button className="success-hero-button">
                  Learn More →
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="join-community" aria-labelledby="join-heading">
        <div className="join-container">
          <h2 id="join-heading">JOIN OUR COMMUNITY</h2>
          <h3>Be Part of Our Success Story</h3>
          <p>Join the Buni Hub community and start your innovation journey today!</p>
          <div className="join-buttons">
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSdDQeKfE3ydjB9X2mhZNe0bZNajM9ilT3EsMh7CbKv4hC2sOw/viewform"
              target="_blank"
              rel="noopener noreferrer"
              className="join-btn"
              aria-label="Apply to join Buni Hub community"
            >
              Apply Now <i className="fas fa-arrow-right" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default SuccessStories;
